<template>
  <div id="app">
    <Application />
  </div>
</template>

<script setup>
import { onBeforeMount } from 'vue'
import Application from './main.vue'
import { initFlowbite } from 'flowbite'

onBeforeMount(() => {
  window.scrollTo(0, 0)
  initFlowbite()
})

</script>

<style lang="scss">
#app {
  max-height: 100vh;
  font-family: Circular, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;

  ::-webkit-scrollbar {
    width: 2px;
    height: 1px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #000;
    border-radius: 2px;
  }

  ::-webkit-scrollbar-track {
    background-color: #d20a0a;
    border-radius: 2px;
  }
}
</style>
